import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-4xl mx-auto text-center">
        <div className="rounded-2xl overflow-hidden relative p-10 md:p-14">
          <img
            src="https://readdy.ai/api/search-image?query=Warm%20cinematic%20home%20theater%20setup%20with%20cozy%20sofa%20facing%20large%20TV%20screen%2C%20soft%20ambient%20orange%20and%20golden%20lighting%2C%20popcorn%20and%20drinks%20on%20coffee%20table%2C%20inviting%20entertainment%20room%20atmosphere%2C%20cinematic%20composition&width=1600&height=600&seq=mango-cta-bg&orientation=landscape"
            alt="芒果视频观影体验"
            className="absolute inset-0 w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/50 to-black/70"></div>

          <div className="relative z-10">
            <h2 className="text-2xl md:text-3xl font-bold text-white font-heading mb-4">
              准备好开启观影之旅了吗？
            </h2>
            <p className="text-white/80 text-sm md:text-base mb-8 max-w-lg mx-auto">
              加入芒果视频，畅享海量高清影视资源。比蜜桃视频、糖豆视频更好用的视频平台，免费体验才刚刚开始。
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
              <Link
                to="/category/dianying"
                className="px-8 py-3.5 bg-primary-500 text-background-50 rounded-lg text-base font-medium hover:bg-primary-600 transition-all transform hover:scale-105 whitespace-nowrap cursor-pointer"
              >
                立即开始观影
                <i className="ri-arrow-right-line ml-2"></i>
              </Link>
              <Link
                to="/article/mangoshipin-app-tiyan"
                className="px-8 py-3.5 bg-white/15 text-white rounded-lg text-base font-medium hover:bg-white/25 transition-all backdrop-blur-sm whitespace-nowrap cursor-pointer"
              >
                查看使用评测
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}